"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var toolkit_1 = require("@reduxjs/toolkit");
var constants_1 = require("./constants");
var config_1 = __importStar(require("../../config"));
var selectors_1 = require("./selectors");
var api_1 = require("../../utils/api");
var types_1 = require("../../middleware/api/types");
var getShowAlbums_1 = __importDefault(require("./queries/getShowAlbums"));
var getMovieAlbums_1 = __importDefault(require("./queries/getMovieAlbums"));
// returns the data we're interested in from the json response
var getResponseData = function (json) { return json.data; };
var baseSpotifyApiAction = {
    authenticated: true,
    includeSkyHeaders: false,
    includeProfileId: false,
    auth: {
        tokenSelector: selectors_1.accessToken,
        errorActionType: constants_1.SPOTIFY_UNAUTHORIZED_ERROR,
    },
    hasResponseData: false,
    getResponseData: getResponseData,
};
exports.setAccessToken = function (spotifyAccessToken) {
    return toolkit_1.createAction(constants_1.SET_ACCESS_TOKEN)(spotifyAccessToken);
};
exports.fetchBrandAlbums = function (brandId, isShow) {
    return api_1.createApiAction(constants_1.FETCH_BRAND_ALBUMS, {
        baseURL: config_1.default.EXP_API_URL + config_1.GRAPH_QL_PATH,
        params: {
            query: isShow ? getShowAlbums_1.default : getMovieAlbums_1.default,
            variables: { brandId: brandId },
        },
        meta: { isShow: isShow },
        authenticated: true,
        graphQL: true,
    });
};
exports.fetchPlayerState = function () {
    return api_1.createApiAction(constants_1.FETCH_PLAYER_STATE, __assign({ baseURL: config_1.default.SPOTIFY_API_URL, path: '/me/player' }, baseSpotifyApiAction));
};
exports.transferPlayback = function (device) {
    return api_1.createApiAction(constants_1.TRANSFER_PLAYBACK, __assign({ baseURL: config_1.default.SPOTIFY_API_URL, method: types_1.HTTPMethod.PUT, path: '/me/player', 
        // eslint-disable-next-line @typescript-eslint/camelcase
        data: { device_ids: [device], play: false } }, baseSpotifyApiAction));
};
exports.play = function (data) {
    return api_1.createApiAction(constants_1.PLAYBACK_PLAY, __assign({ baseURL: config_1.default.SPOTIFY_API_URL, method: types_1.HTTPMethod.PUT, path: '/me/player/play', data: data }, baseSpotifyApiAction));
};
exports.pause = function () {
    return api_1.createApiAction(constants_1.PLAYBACK_PAUSE, __assign({ baseURL: config_1.default.SPOTIFY_API_URL, method: types_1.HTTPMethod.PUT, path: '/me/player/pause' }, baseSpotifyApiAction));
};
exports.setLastSeekTime = function (timestamp) { return toolkit_1.createAction(constants_1.SET_PLAYBACK_SEEK_TIME)(timestamp); };
exports.seek = function (positionMs) {
    return api_1.createApiAction(constants_1.PLAYBACK_SEEK, __assign(__assign({ baseURL: config_1.default.SPOTIFY_API_URL, method: types_1.HTTPMethod.PUT, path: '/me/player/seek', params: { position_ms: positionMs } }, baseSpotifyApiAction), { onRequest: function (dispatch) {
            dispatch(exports.setLastSeekTime(positionMs));
        } }));
};
exports.saveAlbum = function (albumId) {
    return api_1.createApiAction(constants_1.SAVE_ALBUM, __assign({ baseURL: config_1.default.SPOTIFY_API_URL, method: types_1.HTTPMethod.PUT, path: '/me/albums', data: { ids: [albumId] } }, baseSpotifyApiAction));
};
exports.removeAlbum = function (albumId) {
    return api_1.createApiAction(constants_1.REMOVE_ALBUM, __assign({ baseURL: config_1.default.SPOTIFY_API_URL, method: types_1.HTTPMethod.DELETE, path: '/me/albums', data: { ids: [albumId] } }, baseSpotifyApiAction));
};
exports.fetchIsSavedAlbum = function (albumId) {
    return api_1.createApiAction(constants_1.FETCH_IS_SAVED_ALBUM, __assign({ baseURL: config_1.default.SPOTIFY_API_URL, path: '/me/albums/contains', params: { ids: albumId }, meta: { albumId: albumId } }, baseSpotifyApiAction));
};
exports.fetchProfile = function () {
    return api_1.createApiAction(constants_1.FETCH_PROFILE, __assign({ baseURL: config_1.default.SPOTIFY_API_URL, path: '/me' }, baseSpotifyApiAction));
};
//# sourceMappingURL=actions.js.map